module.exports = __webpack_public_path__ + "static/media/emailRounded.864faa5f.svg";